<template>
    <div v-if="isVisible" :class="['fixed-video-box', { 'maximized': isMaximized }]" :data-aos="isMaximized ? null : 'fade-up'" :data-aos-duration="isMaximized ? null : '600'">
        <div class="position-relative dash-box">
            <video autoPlay loop controls muted class="w-100 h-100 my-video rounded-lg">
                <source src="@/assets/videoplayback.mp4" type="video/mp4" />
                Your browser does not support HTML video.
            </video>
            <p @click.prevent="toggleMaximize">
                <svg width="34px" height="34px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path d="M3 12L21 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </svg>
            </p>
        </div>
    </div>
</template>


<script>
export default {
    name: 'FixedVideoBox',
    data() {
        return {
            isMaximized: false,
            isVisible: true
        };
    },
    methods: {
        toggleMaximize() {
            if (this.isMaximized) {
                this.isVisible = false;
            } else {
                this.isMaximized = true;
            }
        }
    }
}
</script>


<style>
.fixed-video-box {
    width: 200px;
    height: 400px;
    position: fixed;
    bottom: -20px;
    right: 0px;
    z-index: 99999;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.fixed-video-box.maximized {
    width: 300px;
    height: 500px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 99999;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.dash-box p {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: white;
    border-radius: 50px;
    width: 40px;
    height: 20px;
    text-align: center;
    cursor: pointer;
}

.dash-box svg {
    padding-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/FixedVideoBox.vue